import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useCountries } from "melco-shared-logic";
import { CountryType } from "../../helper/commonHelper";
import { useRolesContext } from "../../hooks/roles/useRolesContext";


type CountryListProps = {
  onChange: (value: CountryType[]) => void;
  value?: CountryType[];
};

export const CountrySelect: React.FC<CountryListProps> = ({
  value,
  onChange,
}) => {
  const SelectBoxWrapper = styled.div`
  max-width: 300px;
  min-width: 225px;
`;
  const { t } = useTranslation();
  const { countries } = useCountries();
  const { roles } = useRolesContext();

  const countryList = (countries).map(
    (country) => ({
      value: country.code,
      label: country.name,
    })
  );


  let countryAccessFilterListArray: string[] = [];

  countryAccessFilterListArray = roles?.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST?.toString()?.split(",") ?? [];

  countryAccessFilterListArray = countryAccessFilterListArray.map((value) => (value.trim()))
  // console.log(countryAccessFilterListArray)
  // const countryListOptions = countryList.filter((country) => {

  //   if (roles.USERS_COUNTRY_ACCESS_LIST && roles.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST && roles.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST != "") {
  //     if (country.value) {
  //       return countryAccessFilterListArray.includes(country.value)
  //     }
  //   }
  //   else {
  //     return true
  //   }

  // })
  const countryListOptions = countryList.filter((country) => {
    if (
      roles.USERS_COUNTRY_ACCESS_LIST &&
      roles.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST &&
      roles.USERS_COUNTRY_ACCESS_LIST_FILTER_LIST !== ""
    ) {
      if (country.value) {
        return countryAccessFilterListArray.includes(country.value);
      }
      return false; // required for array-callback-return
    } else {
      return true; // required for array-callback-return
    }
  });

  return (
    <SelectBoxWrapper>
      <Select
        mode="multiple"
        allowClear
        placeholder={t("global.label.country_code")}
        style={{ width: "100%", minWidth: "150px" }}
        maxTagCount={1}
        options={countryListOptions}
        onChange={onChange}
        value={value}
        optionFilterProp="label"
        showSearch
      />
    </SelectBoxWrapper>
  );
};
